import React from 'react'
import { Grid } from '@material-ui/core'
import { Delete as DeleteIcon, CheckCircle as CheckCircleIcon } from '@material-ui/icons'
import { Tooltip, IconButton } from '@michelin/acid-components'
import MaterialInputable from './MaterialInputable'
import MaterialSelectable from './MaterialSelectable'
import FormValidator from './FormValidator'
import PropTypes from 'prop-types'

export default class Wheel extends React.Component {
	/**
	 * Default constructor object
	 * @param {props} props - the initial props object
	 * @returns {void} returns void
	 * @public
	 */
	constructor(props) {
		super(props)

		this.validator = this.getValidator(props)

		this.state = {
			validation: this.validator.valid(),
		}

		this.onDiameterChange = this.onDiameterChange.bind(this)
		this.onOffsetChange = this.onOffsetChange.bind(this)
		this.onMaterialChange = this.onMaterialChange.bind(this)
		this.onWheelTypeChange = this.onWheelTypeChange.bind(this)
		this.isValid = this.isValid.bind(this)
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {FormValidator} the current validation object
	 * @public
	 */
	getValidator() {
		return new FormValidator([
			{
				prop: {
					object: 'domain',
					name: 'diameter'
				},
				field: "diameter",
				method: 'isEmpty',
				validWhen: false,
				message: 'Diameter is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'offset'
				},
				field: "offset",
				method: 'isEmpty',
				validWhen: false,
				message: 'Offset is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'material'
				},
				field: "material",
				method: 'isEmpty',
				validWhen: false,
				message: 'Material is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
			{
				prop: {
					object: 'domain',
					name: 'wheelType'
				},
				field: "wheelType",
				method: 'isEmpty',
				validWhen: false,
				message: 'Wheel Type is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly
			},
		])
	}

	/**
	 * Update the validation object value for 'item'
	 * @param {string} item - the item in the validation object to update
	 * @param {boolean} isInvalid - the new state for isInvalid
	 * @param {string} message - the new message to be displayed
	 * @returns {void} returns void
	 * @public
	 */
	updateValidation(item, isInvalid = false, message = '') {
		let validation = Object.assign({}, this.state.validation)
		validation[item].isInvalid = isInvalid
		validation[item].message = message

		this.setState({
			validation: validation
		})
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onDiameterChange(event) {
		this.updateValidation('diameter')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onOffsetChange(event) {
		this.updateValidation('offset')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onMaterialChange(event) {
		this.updateValidation('material')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onWheelTypeChange(event) {
		this.updateValidation('wheelType')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {boolean} is the current object valid?
	 * @public
	 */
	async isValid() {
		const validation = await this.validator.validate(this.state, this.props)
		this.setState({ validation })

		return validation.isValid
	}

	render() {
		const { index, disabled, domain, onRemove, onChange } = this.props
		const { validation } = this.state

		if (domain.isDelete) {
			return null
		}

		this.validator = this.getValidator()

		return (
			<Grid container spacing={1} style={domain.isCreate ? ((index % 2 === 1) ? { background: '#faf8cd' } : { background: '#fffee9' }) : (index % 2 === 1) ? { background: '#efefef' } : null}>
				<Grid item xs={4} sm={4} md={2} lg={1}>
					<MaterialSelectable
						required
						name={index + '_diameter'}
						label="Diameter" 
						value={domain.diameter} 
						disabled={disabled || domain.readOnly}
						error={validation.diameter.isInvalid}
						errorMessage={validation.diameter.message}
						onChange={this.onDiameterChange}
						options={this.props.wheelDiameterOptions} />
				</Grid>
				<Grid item xs={4} sm={4} md={2} lg={1}>
					<MaterialSelectable
						required
						value={domain.offset}
						name={index + "_offset"}
						disabled={disabled || domain.readOnly}
						label="Offset"
						error={validation.offset.isInvalid}
						errorMessage={validation.offset.message}
						onChange={this.onOffsetChange}
						options={this.props.wheelOffsetOptions} />
				</Grid>
				<Grid item xs={4} sm={4} md={2} lg={1}>
					<MaterialSelectable 
						required
						value={domain.material} 
						name={index + "_material"} 
						label="Material" 
						disabled={disabled || domain.readOnly}
						error={validation.material.isInvalid}
						errorMessage={validation.material.message}
						onChange={this.onMaterialChange}
						options={this.props.wheelMaterialTypeOptions} />
				</Grid>
				<Grid item xs={6} lg={2}>
					<MaterialSelectable 
						required
						value={domain.wheelType} 
						name={index + "_wheelType"}
						label="Type"
						disabled={disabled || domain.readOnly}
						error={validation.wheelType.isInvalid}
						errorMessage={validation.wheelType.message}
						onChange={this.onWheelTypeChange}
						options={this.props.wheelTypeOptions} />
				</Grid>
				<Grid item xs={6} lg={2}>
					<MaterialInputable 
						name={index + "_colorFinish"} 
						label="Color/Finish" 
						value={domain.colorFinish || ''}
						defaultValue={domain.colorFinish} 
						disabled={disabled || domain.readOnly}
						onChange={onChange} />
				</Grid>
				<Grid item xs={12} md={4} lg={4}>
					<MaterialInputable 
						name={index + '_comments'} 
						label="Comments" 
						value={domain.comments || ''}
						defaultValue={domain.comments}
						disabled={disabled || domain.readOnly}
						onChange={onChange} />
				</Grid>
				<Grid item xs={12} md={2} lg={1} style={{ alignSelf: 'center' }}>
					{!(disabled || domain.readOnly) &&
					<Tooltip title="Delete">
						<IconButton aria-label="Delete" onClick={() => onRemove(index)} disabled={domain.readOnly} size="small" variant="contained" color="primary">
							<DeleteIcon fontSize="small" />
						</IconButton>
					</Tooltip>
					}

					{process.env.NODE_ENV !== 'production' &&
						<Tooltip title="Validate">
							<IconButton aria-label="Validate" onClick={this.isValid} size="small" variant="contained" color="primary" style={{ marginLeft: '8px' }}>
								<CheckCircleIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					}
				</Grid>
			</Grid>
		)
	}
}

Wheel.propTypes = {
	classes: PropTypes.object,
	index: PropTypes.number,
	recordCount: PropTypes.number,
	disabled: PropTypes.bool,
	domain: PropTypes.object,
	onRemove: PropTypes.func,
	onChange: PropTypes.func,
	onComment: PropTypes.func,
	onChangeSelect: PropTypes.func,
	wheelDiameterOptions: PropTypes.array,
	wheelOffsetOptions: PropTypes.array,
	wheelMaterialTypeOptions: PropTypes.array,
	wheelTypeOptions: PropTypes.array,
}

Wheel.defaultProps = {
	disabled: false,
}



// WEBPACK FOOTER //
// ./src/components/Wheel.js